define('Store.Facets.EntryPoint', [
    'Profile.Model',
    'SC.Configuration',
    'underscore',
    'Store.Facets.ItemListSortSelector.View',
    'Store.Facets.Translator'
], function StoreFacetsEntryPoint(
    ProfileModel,
    Configuration,
    _
) {
    'use strict';

    function addToSearchAPIMasterOptions(apiOptions) {
        var profile = ProfileModel.getInstance();
        var store = profile.get('store');
        var facetsConfiguration = Configuration.get('facets');
        var facetExclude = [];
        var pricelevel = profile.get('priceLevel');
        var defaultPricelevel = SC.ENVIRONMENT.siteSettings.defaultpricelevel;

        _.each(facetsConfiguration, function eachFacet(facet) {
            if (facet.storeId && facet.storeId + '' !== store.get('internalid') + '') {
                facetExclude.push(facet.id);
            }
        });

        if (pricelevel !== defaultPricelevel && store && store.get('priceField')) {
            facetExclude.push(store.get('priceField').toLowerCase());
        }

        _.each(apiOptions, function eachApiOptions(value) {
            value['facet.exclude'] = value['facet.exclude'] ? value['facet.exclude'] + ',' + facetExclude.join(',') :
                facetExclude.join(',');
        });

        return apiOptions;
    }

    return {
        mountToApp: function mountToApp(application) {
            var plp = application.getComponent('PLP');
            Configuration.searchApiMasterOptions = addToSearchAPIMasterOptions(
                Configuration.searchApiMasterOptions
            );
            try {
                plp.addToViewContextDefinition('Facets.Browse.View', 'storeName', 'string', function fbStore() {
                    return ProfileModel.getInstance().get('store') &&
                        ProfileModel.getInstance().get('store').get('name');
                });
            } catch (e) {
                console.error(e);
            }
            try {
                plp.addToViewContextDefinition('SearchSpring.Search.View', 'storeName', 'string', function fbStore() {
                    return ProfileModel.getInstance().get('store') &&
                        ProfileModel.getInstance().get('store').get('name');
                });
            } catch (e) {
                console.error(e);
            }
        }
    };
});
